import { MatchDetailItemFragment } from '@amf/shared/types/graphql';
import Container from '@amf/shared/components/layout/Container';
import { useTranslate } from '@tolgee/react';
import { useState } from 'react';
import classNames from 'classnames';
import MatchEventsTimeline from '@amf/shared/components/match/MatchEventsTimeline';
import MatchEventsTable from '@amf/shared/components/match/MatchEventsTable';
import Tabs from '@amf/shared/components/menu/Tabs';

enum MatchEventsViewType {
  timeline = 'timeline',
  table = 'table',
}

interface MatchEventsProps {
  match: MatchDetailItemFragment;
  homeTeamId: string;
  prefixes: { team: string; player: string; offense?: string };
  facr?: boolean;
}

function MatchEvents({ match, homeTeamId, prefixes, facr }: MatchEventsProps) {
  const { t } = useTranslate();
  const [view, setView] = useState(MatchEventsViewType.table);

  if (match.eventsStandard.length === 0) {
    return null;
  }

  return (
    <div
      className={classNames('MatchEvents', {
        'MatchEvents--list': view === MatchEventsViewType.table,
      })}
    >
      <Container>
        <div className='MatchEvents__header'>
          <h2 className='MatchEvents__title'>{t('match.event.list.title')}</h2>
          <Tabs<MatchEventsViewType>
            onChange={setView}
            selected={view}
            items={[
              { title: t('match.event.list.view.table'), value: MatchEventsViewType.table },
              { title: t('match.event.list.view.timeline'), value: MatchEventsViewType.timeline },
            ]}
          />
        </div>
      </Container>
      <Container className='MatchEvents__container'>
        <div className='MatchEvents__content'>
          {view === MatchEventsViewType.timeline && (
            <MatchEventsTimeline
              match={match}
              playerPrefix={prefixes.player}
              homeTeamId={homeTeamId}
              offensePrefix={prefixes.offense}
              facr={facr}
            />
          )}
          {view === MatchEventsViewType.table && (
            <MatchEventsTable
              match={match}
              prefixes={prefixes}
              homeTeamId={homeTeamId}
              facr={facr}
            />
          )}
        </div>
      </Container>
    </div>
  );
}

export default MatchEvents;
